import { Popover, PopoverContent, PopoverTrigger, SearchInput, useDisclosure } from '@ds';
import React from 'react';
import { MdOutlineHistory } from 'react-icons/md';

type CaseSearchInputProps = {
  handleSearch: (text: string) => void;
  searchText?: string;
  storageKey: string;
};

const MAX_RESULTS_NUMBER = 5;

export const SearchInputWithHistory = ({ handleSearch, searchText, storageKey }: CaseSearchInputProps) => {
  const { isOpen, onOpenChange, onClose } = useDisclosure();

  const searchHistory: string[] = JSON.parse(localStorage.getItem(storageKey) as string) || [];

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleSearch(e.target.value);
    onClose();
  };

  const selectSuggestion = (item: string) => {
    handleSearch(item);
    onClose();
  };

  const saveLastSearch = () => {
    let results = [...searchHistory];

    if (!searchText) return;
    if (searchText && results.includes(searchText)) return;

    results.unshift(searchText);
    if (results.length >= MAX_RESULTS_NUMBER) {
      results = results.slice(0, MAX_RESULTS_NUMBER);
    }
    localStorage.setItem(storageKey, JSON.stringify(results));
  };

  const stopPopoverPropagation = (e: React.KeyboardEvent<HTMLInputElement>) => e.stopPropagation();

  return (
    <Popover
      isOpen={isOpen}
      placement="bottom-start"
      size="md"
      triggerScaleOnOpen={false}
      offset={8}
      onOpenChange={onOpenChange}
      classNames={{ content: 'items-stretch' }}
    >
      <PopoverTrigger>
        <div>
          <SearchInput
            isClearable
            onKeyDown={stopPopoverPropagation}
            className="w-[265px]"
            placeholder="Search"
            type="text"
            value={searchText}
            onClear={() => handleSearch('')}
            onChange={onChange}
            onBlur={saveLastSearch}
            inputVariant="secondary"
          />
        </div>
      </PopoverTrigger>
      {searchHistory.length > 0 && (
        <PopoverContent tabIndex={undefined} className="gap-4 p-4 w-[265px] bg-base-60 rounded-xl">
          <div className="text-s-m text-base-5 px-2">Recent Searches</div>
          <div className="flex flex-col">
            {searchHistory.map((result) => (
              <button
                key={result}
                className="p-2 hover:bg-base-40 flex text-m-r gap-2 items-center rounded-md"
                onClick={() => selectSuggestion(result)}
              >
                <MdOutlineHistory size={18} />
                <div className="text-start w-full text-ellipsis overflow-hidden whitespace-nowrap">{result}</div>
              </button>
            ))}
          </div>
        </PopoverContent>
      )}
    </Popover>
  );
};
